import React from 'react';
import { Footer } from '../Issues/common';
import { componentMap } from '../../../serverDrivenUIComponents/compMapping';

export const getSuccessDetails = (children) => {
  if (!children || !Array.isArray(children) || children.length === 0) {
    return null;
  }
  return children.map((child, index) => {
    if (!child || !child.type) return null;
    let CompName = '';
    if (child.type in componentMap) {
      CompName = componentMap[child.type];
      return (
        <div className='tw-pt-4 tw-w-full' key={`${child.type}-${index}`}>
          <CompName details={child} />
        </div>
      );
    } else return null;
  });
};

export default function SuccessScreen({ details, goBack = () => {} }) {
  return (
    <div className='tw-flex tw-flex-col tw-gap-6 tw-w-full tw-p-6 tw-overflow-y-auto tw-items-center tw-justify-center tw-min-h-full'>
      <div
        className={`tw-flex tw-flex-col tw-text-base-black tw-text-300 tw-font-extrabold tw-gap-6 tw-w-full  tw-justify-center tw-items-center tw-min-h-full tw-overflow-y-auto ${
          details?.children?.length > 1 ? 'tw-my-[7rem]' : ''
        } ]`}
      >
        <span className='tw-w-28 tw-h-28'>
          <img src={details?.image} alt='item' width='100%' height='100%' />
        </span>
        <div className='tw-text-700 tw-font-bold tw-text-grey-900'>
          {details?.title}
        </div>
        <div className='tw-text-400 tw-font-medium tw-text-grey-600'>
          {details?.subtitle}
        </div>
        <div
          className={`tw-w-full tw-flex ${
            details?.orientation === 'horizontal'
              ? 'tw-flex-row'
              : 'tw-flex-col'
          }`}
        >
          {getSuccessDetails(details?.children)}
        </div>
      </div>
      <Footer
        submitBtnTitle='Done'
        btnBgColor='#0C831F'
        sendFormData={goBack}
      />
    </div>
  );
}
